var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "view-tasklists" },
    [
      _c("user-menu"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "wrapper" },
        [
          _c("masteradmin-sidebar-menu"),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "content-wrapper" },
            [
              _c("div", { staticClass: "container-wrapper center" }, [
                _c("div", [
                  _c("h3", { staticClass: "d-inline heading" }, [
                    _vm._v("Subscription Level")
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass:
                        "d-inline btn btn-red float-right create-btn",
                      on: {
                        click: function($event) {
                          ;(_vm.isModalVisible = true), _vm.verrors.clear()
                        }
                      }
                    },
                    [
                      _c("i", {
                        staticClass: "fa fa-plus spacer-icon",
                        attrs: { "aria-hidden": "true" }
                      }),
                      _vm._v("Purchase Type\n                    ")
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "heading-seperator" }),
                _vm._v(" "),
                _c("div", { staticClass: "margin-bottom-10" }),
                _vm._v(" "),
                _c(
                  "div",
                  {},
                  [
                    _c(
                      "b-navbar",
                      {
                        attrs: {
                          toggleable: "lg",
                          type: "light",
                          variant: "light"
                        }
                      },
                      [
                        _c("b-navbar-brand", { attrs: { href: "#" } }, [
                          _vm._v("Filter/Search")
                        ]),
                        _vm._v(" "),
                        _c(
                          "b-navbar-toggle",
                          { attrs: { target: "nav-collapse" } },
                          [_c("i", { staticClass: "fa fa-chevron-down\t" })]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-collapse",
                          { attrs: { id: "nav-collapse", "is-nav": "" } },
                          [
                            _c(
                              "div",
                              { staticClass: "search-wrapper col-12" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "row col-12 override-padding"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "col-lg-3 col-md-3 col-3"
                                      },
                                      [
                                        _c("b-form-select", {
                                          staticClass: "input-text",
                                          attrs: {
                                            options: _vm.unitTypeOptions
                                          },
                                          model: {
                                            value: _vm.search_unit_type,
                                            callback: function($$v) {
                                              _vm.search_unit_type = $$v
                                            },
                                            expression: "search_unit_type"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "col-lg-3 col-md-3 col-3"
                                      },
                                      [
                                        _c("b-form-input", {
                                          staticClass: "input-text",
                                          attrs: {
                                            type: "text",
                                            placeholder: "License Name"
                                          },
                                          model: {
                                            value: _vm.search_name,
                                            callback: function($$v) {
                                              _vm.search_name = $$v
                                            },
                                            expression: "search_name"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "col-lg-3 col-md-3 col-3"
                                      },
                                      [
                                        _c("b-form-select", {
                                          staticClass: "input-text",
                                          attrs: {
                                            options: _vm.validityDurationOptions
                                          },
                                          model: {
                                            value: _vm.search_validity_duration,
                                            callback: function($$v) {
                                              _vm.search_validity_duration = $$v
                                            },
                                            expression:
                                              "search_validity_duration"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "col-lg-2 col-md-2 col-2"
                                      },
                                      [
                                        _c("b-form-select", {
                                          staticClass: "input-text",
                                          attrs: {
                                            options: _vm.packageStatusOptions
                                          },
                                          model: {
                                            value: _vm.search_is_active,
                                            callback: function($$v) {
                                              _vm.search_is_active = $$v
                                            },
                                            expression: "search_is_active"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-lg-1 col-md-1 col-1 search-icon-wrapper cursor-pointer",
                                        on: {
                                          click: function($event) {
                                            return _vm.filterPackagelistitems()
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "search-icon" },
                                          [
                                            _c("i", {
                                              staticClass: "fa fa-search"
                                            })
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "margin-bottom-10" }),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c(
                      "b-card",
                      { attrs: { "no-body": "" } },
                      [
                        _c("div", { staticClass: "row tasks_heading_row" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "bold cursor-pointer col-xl-2 col-lg-2 col-md-2 col-sm-3 col-3",
                              on: {
                                click: function($event) {
                                  return _vm.sortMethod("unitType")
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                                Unit Type\n                                "
                              ),
                              _vm.sortField == "unitType" &&
                              _vm.publicSortBy == "ASC"
                                ? _c("i", {
                                    staticClass: "fa fa-sort-asc",
                                    attrs: { "aria-hidden": "true" }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.sortField == "unitType" &&
                              _vm.publicSortBy == "DESC"
                                ? _c("i", {
                                    staticClass: "fa fa-sort-desc",
                                    attrs: { "aria-hidden": "true" }
                                  })
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "bold cursor-pointer col-xl-2 col-lg-2 col-md-2 col-sm-3 col-3",
                              on: {
                                click: function($event) {
                                  return _vm.sortMethod("licenseType")
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                                License Type\n                                "
                              ),
                              _vm.sortField == "licenseType" &&
                              _vm.publicSortBy == "ASC"
                                ? _c("i", {
                                    staticClass: "fa fa-sort-asc",
                                    attrs: { "aria-hidden": "true" }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.sortField == "licenseType" &&
                              _vm.publicSortBy == "DESC"
                                ? _c("i", {
                                    staticClass: "fa fa-sort-desc",
                                    attrs: { "aria-hidden": "true" }
                                  })
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "bold cursor-pointer col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 override-padding",
                              on: {
                                click: function($event) {
                                  return _vm.sortMethod("name")
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                                License Name\n                                "
                              ),
                              _vm.sortField == "name" &&
                              _vm.publicSortBy == "ASC"
                                ? _c("i", {
                                    staticClass: "fa fa-sort-asc",
                                    attrs: { "aria-hidden": "true" }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.sortField == "name" &&
                              _vm.publicSortBy == "DESC"
                                ? _c("i", {
                                    staticClass: "fa fa-sort-desc",
                                    attrs: { "aria-hidden": "true" }
                                  })
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "bold col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 override-padding"
                            },
                            [
                              _vm._v(
                                "\n                                Price                                    \n                            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "bold cursor-pointer col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 override-padding",
                              on: {
                                click: function($event) {
                                  return _vm.sortMethod("validityDuration")
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                                Validity Duration\n                                "
                              ),
                              _vm.sortField == "validityDuration" &&
                              _vm.publicSortBy == "ASC"
                                ? _c("i", {
                                    staticClass: "fa fa-sort-asc",
                                    attrs: { "aria-hidden": "true" }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.sortField == "validityDuration" &&
                              _vm.publicSortBy == "DESC"
                                ? _c("i", {
                                    staticClass: "fa fa-sort-desc",
                                    attrs: { "aria-hidden": "true" }
                                  })
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "bold cursor-pointer col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 override-padding",
                              on: {
                                click: function($event) {
                                  return _vm.sortMethod("isActive")
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                                Status\n                                "
                              ),
                              _vm.sortField == "isActive" &&
                              _vm.publicSortBy == "ASC"
                                ? _c("i", {
                                    staticClass: "fa fa-sort-asc",
                                    attrs: { "aria-hidden": "true" }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.sortField == "isActive" &&
                              _vm.publicSortBy == "DESC"
                                ? _c("i", {
                                    staticClass: "fa fa-sort-desc",
                                    attrs: { "aria-hidden": "true" }
                                  })
                                : _vm._e()
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.loading,
                                expression: "loading"
                              }
                            ],
                            staticClass: "loading_show"
                          },
                          [
                            _c("div", {
                              staticClass: "spinner-border text-danger"
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _vm.package_lists.length > 0
                          ? _c(
                              "b-card-text",
                              [
                                _vm._l(_vm.package_lists, function(
                                  packagelist,
                                  index
                                ) {
                                  return _c(
                                    "div",
                                    { staticClass: "tasklist-row" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "row tasklist-item",
                                          staticStyle: { margin: "0" }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-xl-2 col-lg-2 col-md-2 col-sm-3 col-3 package-name"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(packagelist.unitType)
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-xl-2 col-lg-2 col-md-2 col-sm-3 col-3 package-name"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(packagelist.licenseType)
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 override-padding"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(packagelist.licenseName)
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          packagelist.licenseType ==
                                          "Bundle License"
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 override-padding"
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "fa fa-dollar"
                                                  }),
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.formatNumber(
                                                        packagelist.bundlePrice
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            : packagelist.unitType == "Seat"
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 override-padding"
                                                },
                                                [
                                                  _vm._v("Starts with "),
                                                  _c("i", {
                                                    staticClass: "fa fa-dollar"
                                                  }),
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.formatNumber(
                                                        packagelist.startingSeatPrice
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            : packagelist.price != null
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 override-padding"
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "fa fa-dollar"
                                                  }),
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.formatNumber(
                                                        packagelist.price
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            : _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 override-padding"
                                                },
                                                [
                                                  _vm._v("Starts with "),
                                                  _c("i", {
                                                    staticClass: "fa fa-dollar"
                                                  }),
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.formatNumber(
                                                        packagelist.startingPrice
                                                      )
                                                    )
                                                  )
                                                ]
                                              ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 override-padding"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.getValidityDuration(
                                                    packagelist.validityDuration
                                                  )
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-xl-1 col-lg-1 col-md-2 col-sm-2 col-2 override-padding"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.getStatus(
                                                    packagelist.isActive
                                                  )
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-xl-1 col-lg-1 col-md-1 col-sm-1 col-1 override-padding"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "dropdown",
                                                  attrs: {
                                                    id:
                                                      "dropdown-container" +
                                                      index
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.toggleDropdown(
                                                        "actionDropdown" +
                                                          index +
                                                          ""
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "ul",
                                                    {
                                                      staticClass:
                                                        "dropbtn icons btn-right showLeft",
                                                      attrs: {
                                                        id:
                                                          "dotted-menu" + index
                                                      }
                                                    },
                                                    [
                                                      _c("li"),
                                                      _vm._v(" "),
                                                      _c("li"),
                                                      _vm._v(" "),
                                                      _c("li")
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "dropdown-content",
                                                      attrs: {
                                                        id:
                                                          "actionDropdown" +
                                                          index
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "action-dd-menu",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.goToEdit(
                                                                packagelist
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "cursor-pointer fa fa-edit spacer-icon"
                                                          }),
                                                          _vm._v("Edit")
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("div", [_c("hr")])
                                    ]
                                  )
                                }),
                                _vm._v(" "),
                                _vm.rows > 25
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "overflow-auto float-right pagination-wrapper"
                                      },
                                      [
                                        _c("b-pagination", {
                                          attrs: {
                                            "total-rows": _vm.rows,
                                            "per-page": _vm.perPage,
                                            "first-text": "First",
                                            "prev-text": "Prev",
                                            "next-text": "Next",
                                            "last-text": "Last",
                                            "hide-goto-end-buttons": false
                                          },
                                          on: {
                                            input: function($event) {
                                              return _vm.showPackageofPaginated()
                                            }
                                          },
                                          model: {
                                            value: _vm.currentPage,
                                            callback: function($$v) {
                                              _vm.currentPage = $$v
                                            },
                                            expression: "currentPage"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              2
                            )
                          : _vm.loading == false
                          ? _c("b-card-text", [
                              _vm._v(
                                "\n                                No Package found.\n                        "
                              )
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "CreateSubscriptionModal",
                {
                  attrs: { isModalVisible: _vm.isModalVisible },
                  on: {
                    close: function($event) {
                      _vm.isModalVisible = false
                    }
                  }
                },
                [
                  _vm.loading
                    ? _c("span", { staticClass: "pull-right text-danger" }, [
                        _vm._v("\n                Loading...\n                ")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "sub-heading",
                      attrs: { slot: "header" },
                      slot: "header"
                    },
                    [_c("h3", [_vm._v("Create Purchase Type")])]
                  ),
                  _vm._v(" "),
                  _vm.isModalVisible === true
                    ? _c(
                        "div",
                        { attrs: { slot: "body" }, slot: "body" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "col-lg-12 col-12 override-padding"
                            },
                            [
                              _c("b-form-select", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                staticClass: "input-text",
                                attrs: {
                                  options: _vm.unitTypeOptions,
                                  name: "Unit Type"
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.unitTypeChange()
                                  }
                                },
                                model: {
                                  value: _vm.unit_type,
                                  callback: function($$v) {
                                    _vm.unit_type = $$v
                                  },
                                  expression: "unit_type"
                                }
                              }),
                              _vm._v(" "),
                              _vm.verrors.firstByRule("Unit Type", "required")
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "margin-bottom-5 validate-warning-msg"
                                    },
                                    [_vm._v("Unit Type is required")]
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "margin-bottom-10",
                            staticStyle: { clear: "both" }
                          }),
                          _vm._v(" "),
                          _vm.unit_type == "License"
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "col-lg-12 col-12 override-padding"
                                },
                                [
                                  _c("b-form-select", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required",
                                        expression: "'required'"
                                      }
                                    ],
                                    staticClass: "input-text",
                                    attrs: {
                                      options: _vm.licenseTypeOptions,
                                      name: "License Type"
                                    },
                                    model: {
                                      value: _vm.license_type,
                                      callback: function($$v) {
                                        _vm.license_type = $$v
                                      },
                                      expression: "license_type"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _vm.verrors.firstByRule(
                                    "License Type",
                                    "required"
                                  )
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "margin-bottom-5 validate-warning-msg"
                                        },
                                        [_vm._v("License Type is required")]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "margin-bottom-10",
                            staticStyle: { clear: "both" }
                          }),
                          _vm._v(" "),
                          _vm.unit_type == "License" || _vm.unit_type == "Seat"
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "col-lg-12 col-12 override-padding"
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.license_name,
                                        expression: "license_name"
                                      },
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required",
                                        expression: "'required'"
                                      }
                                    ],
                                    staticClass:
                                      "col-12 input-text form-control",
                                    attrs: {
                                      placeholder: "License Name",
                                      name: "License Name",
                                      maxlength: "150"
                                    },
                                    domProps: { value: _vm.license_name },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.license_name = $event.target.value
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _vm.verrors.firstByRule(
                                    "License Name",
                                    "required"
                                  )
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "margin-bottom-5 validate-warning-msg"
                                        },
                                        [_vm._v("License Name is required")]
                                      )
                                    : _vm._e()
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticStyle: { clear: "both" } }),
                          _vm._v(" "),
                          _vm.unit_type == "One Time Purchase"
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "col-lg-12 col-12 override-padding"
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.price_onetime,
                                        expression: "price_onetime"
                                      },
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required",
                                        expression: "'required'"
                                      }
                                    ],
                                    staticClass:
                                      "col-12 input-text form-control",
                                    attrs: {
                                      placeholder: "Price",
                                      name: "Price",
                                      maxlength: "8"
                                    },
                                    domProps: { value: _vm.price_onetime },
                                    on: {
                                      blur: function($event) {
                                        return _vm.formatOneTimePrice(
                                          $event,
                                          "add"
                                        )
                                      },
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.price_onetime = $event.target.value
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _vm.verrors.firstByRule("Price", "required")
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "margin-bottom-5 validate-warning-msg"
                                        },
                                        [_vm._v("Price is required")]
                                      )
                                    : _vm._e()
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.unit_type == "License" &&
                          _vm.license_type == "Bundle License"
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "col-lg-12 col-12 override-padding mt-2"
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "col-8 p-0 float-left" },
                                    [
                                      _c("div", { staticClass: "col-12 p-0" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "col-7 p-0 float-left",
                                            staticStyle: { "margin-top": "5px" }
                                          },
                                          [
                                            _vm._v(
                                              "\n                            Minimum License: \n                          "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "col-5 p-0 float-left"
                                          },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.license_qty,
                                                  expression: "license_qty"
                                                },
                                                {
                                                  name: "validate",
                                                  rawName: "v-validate",
                                                  value: "required|numeric",
                                                  expression:
                                                    "'required|numeric'"
                                                }
                                              ],
                                              staticClass:
                                                "col-12 input-text form-control",
                                              attrs: {
                                                placeholder: "Quantity",
                                                name: "License Quantity",
                                                maxlength: "2"
                                              },
                                              domProps: {
                                                value: _vm.license_qty
                                              },
                                              on: {
                                                input: function($event) {
                                                  if ($event.target.composing) {
                                                    return
                                                  }
                                                  _vm.license_qty =
                                                    $event.target.value
                                                }
                                              }
                                            }),
                                            _vm._v(" "),
                                            _vm.verrors.firstByRule(
                                              "License Quantity",
                                              "required"
                                            )
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "margin-bottom-5 validate-warning-msg"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Minimum Quantity is required"
                                                    )
                                                  ]
                                                )
                                              : _vm.verrors.firstByRule(
                                                  "License Quantity",
                                                  "numeric"
                                                )
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "margin-bottom-5 validate-warning-msg"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Minimum Quantity should be numeric"
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticClass: "margin-bottom-20",
                                          staticStyle: { clear: "both" }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-12 p-0" },
                                          [
                                            _vm._v(
                                              "\n                            Price per license (After Bundle):\n                          "
                                            )
                                          ]
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "col-4 p-0 float-left",
                                      staticStyle: {
                                        "padding-left": "15px !important"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-12 p-0 text-align-right"
                                        },
                                        [
                                          _vm._v(
                                            "\n                          $ "
                                          ),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.bundle_price,
                                                expression: "bundle_price"
                                              },
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required|decimal:2",
                                                expression:
                                                  "'required|decimal:2'"
                                              }
                                            ],
                                            staticClass:
                                              "col-10 input-text form-control license-range-price",
                                            attrs: {
                                              placeholder: "Price",
                                              name: "Price Bundle",
                                              maxlength: "8"
                                            },
                                            domProps: {
                                              value: _vm.bundle_price
                                            },
                                            on: {
                                              blur: function($event) {
                                                return _vm.formatBundlePrice(
                                                  $event,
                                                  "add"
                                                )
                                              },
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.bundle_price =
                                                  $event.target.value
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _vm.verrors.firstByRule(
                                            "Price Bundle",
                                            "required"
                                          )
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "text-left margin-bottom-5 validate-warning-msg"
                                                },
                                                [
                                                  _vm._v(
                                                    "Bundle Price is required"
                                                  )
                                                ]
                                              )
                                            : _vm.verrors.firstByRule(
                                                "Price Bundle",
                                                "decimal"
                                              )
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "text-left margin-bottom-5 validate-warning-msg"
                                                },
                                                [
                                                  _vm._v(
                                                    "Price should be numeric and may contain 2 decimal points"
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-12 p-0 text-align-right",
                                          staticStyle: { "margin-top": "10px" }
                                        },
                                        [
                                          _vm._v(
                                            "\n                          $ "
                                          ),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.price_after_bundle,
                                                expression: "price_after_bundle"
                                              },
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required|decimal:2",
                                                expression:
                                                  "'required|decimal:2'"
                                              }
                                            ],
                                            staticClass:
                                              "col-10 input-text form-control license-range-price",
                                            attrs: {
                                              placeholder: "Price",
                                              name: "Price After Bundle",
                                              maxlength: "8"
                                            },
                                            domProps: {
                                              value: _vm.price_after_bundle
                                            },
                                            on: {
                                              blur: function($event) {
                                                return _vm.formatPriceAfterBundle(
                                                  $event,
                                                  "add"
                                                )
                                              },
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.price_after_bundle =
                                                  $event.target.value
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _vm.verrors.firstByRule(
                                            "Price After Bundle",
                                            "required"
                                          )
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "text-left margin-bottom-5 validate-warning-msg"
                                                },
                                                [_vm._v("Price is required")]
                                              )
                                            : _vm.verrors.firstByRule(
                                                "Price After Bundle",
                                                "decimal"
                                              )
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "text-left margin-bottom-5 validate-warning-msg"
                                                },
                                                [
                                                  _vm._v(
                                                    "Price should be numeric and may contain 2 decimal points"
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticStyle: { clear: "both" } }),
                          _vm._v(" "),
                          _vm._l(_vm.priceTier, function(list, pindex) {
                            return _vm.unit_type == "License" &&
                              _vm.license_type == "Normal License"
                              ? _c(
                                  "div",
                                  {
                                    key: pindex,
                                    staticClass:
                                      "col-lg-12 col-12 override-padding mt-2"
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: list.license_from,
                                          expression: "list.license_from"
                                        },
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "required|numeric",
                                          expression: "'required|numeric'"
                                        }
                                      ],
                                      staticClass:
                                        "input-text form-control license-range-input",
                                      attrs: {
                                        placeholder: "",
                                        name: "rangeFrom[" + pindex + "]",
                                        maxlength: "4"
                                      },
                                      domProps: { value: list.license_from },
                                      on: {
                                        blur: function($event) {
                                          return _vm.checkPriceRangeNumbers(
                                            pindex,
                                            "From"
                                          )
                                        },
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            list,
                                            "license_from",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(
                                      "\n                                  ―    \n                            "
                                    ),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: list.license_to,
                                          expression: "list.license_to"
                                        },
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "required|numeric",
                                          expression: "'required|numeric'"
                                        }
                                      ],
                                      staticClass:
                                        "input-text form-control license-range-input",
                                      attrs: {
                                        placeholder: "",
                                        name: "rangeTo[" + pindex + "]",
                                        maxlength: "4"
                                      },
                                      domProps: { value: list.license_to },
                                      on: {
                                        blur: function($event) {
                                          return _vm.checkPriceRangeNumbers(
                                            pindex,
                                            "To"
                                          )
                                        },
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            list,
                                            "license_to",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(
                                      "       \n                            $ "
                                    ),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: list.license_price,
                                          expression: "list.license_price"
                                        },
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "required|decimal:2",
                                          expression: "'required|decimal:2'"
                                        }
                                      ],
                                      staticClass:
                                        "col-3 input-text form-control license-range-price",
                                      attrs: {
                                        placeholder: "Price",
                                        name: "price[" + pindex + "]",
                                        id: "price1",
                                        maxlength: "8"
                                      },
                                      domProps: { value: list.license_price },
                                      on: {
                                        blur: function($event) {
                                          return _vm.formatPrice($event, pindex)
                                        },
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            list,
                                            "license_price",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "delete-icon" }, [
                                      _c("i", {
                                        staticClass:
                                          "fa fa-window-close cursor-pointer",
                                        attrs: { "aria-hidden": "true" },
                                        on: {
                                          click: function($event) {
                                            return _vm.removePriceTier(pindex)
                                          }
                                        }
                                      })
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "row" }, [
                                      _vm.verrors.firstByRule(
                                        "rangeFrom[" + pindex + "]",
                                        "required"
                                      )
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-4 margin-bottom-5 validate-warning-msg"
                                            },
                                            [_vm._v("Range From is required")]
                                          )
                                        : _vm.verrors.firstByRule(
                                            "rangeFrom[" + pindex + "]",
                                            "numeric"
                                          )
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-4 margin-bottom-5 validate-warning-msg"
                                            },
                                            [
                                              _vm._v(
                                                "Range From should be numeric"
                                              )
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-4 margin-bottom-5"
                                            },
                                            [_vm._v(" ")]
                                          ),
                                      _vm._v(" "),
                                      _vm.verrors.firstByRule(
                                        "rangeTo[" + pindex + "]",
                                        "required"
                                      )
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-4 margin-bottom-5 validate-warning-msg"
                                            },
                                            [_vm._v("Range To is required")]
                                          )
                                        : _vm.verrors.firstByRule(
                                            "rangeTo[" + pindex + "]",
                                            "numeric"
                                          )
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-4 margin-bottom-5 validate-warning-msg"
                                            },
                                            [
                                              _vm._v(
                                                "Range To should be numeric"
                                              )
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-4 margin-bottom-5"
                                            },
                                            [_vm._v(" ")]
                                          ),
                                      _vm._v(" "),
                                      _vm.verrors.firstByRule(
                                        "price[" + pindex + "]",
                                        "required"
                                      )
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-4 margin-bottom-5 validate-warning-msg"
                                            },
                                            [_vm._v(" Price is required")]
                                          )
                                        : _vm.verrors.firstByRule(
                                            "price[" + pindex + "]",
                                            "decimal"
                                          )
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-4 margin-bottom-5 validate-warning-msg"
                                            },
                                            [
                                              _vm._v(
                                                "Price should be numeric and may contain 2 decimal points"
                                              )
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-4 margin-bottom-5"
                                            },
                                            [_vm._v(" ")]
                                          )
                                    ])
                                  ]
                                )
                              : _vm._e()
                          }),
                          _vm._v(" "),
                          _c("div", { staticStyle: { clear: "both" } }),
                          _vm._v(" "),
                          _vm.unit_type == "License" &&
                          _vm.license_type == "Normal License"
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "float-right price-range-wrapper",
                                  on: {
                                    click: function($event) {
                                      return _vm.addMorePriceTier()
                                    }
                                  }
                                },
                                [_vm._v(" + Add License Price Range")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "margin-bottom-10",
                            staticStyle: { clear: "both" }
                          }),
                          _vm._v(" "),
                          _vm.unit_type == "One Time Purchase"
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "col-lg-12 col-12 override-padding"
                                },
                                [
                                  _c("b-form-select", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required",
                                        expression: "'required'"
                                      }
                                    ],
                                    staticClass: "input-text",
                                    attrs: {
                                      options: _vm.accountTypeOptions,
                                      name: "Account Type"
                                    },
                                    model: {
                                      value: _vm.account_type,
                                      callback: function($$v) {
                                        _vm.account_type = $$v
                                      },
                                      expression: "account_type"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _vm.verrors.firstByRule(
                                    "Account Type",
                                    "required"
                                  )
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "margin-bottom-5 validate-warning-msg"
                                        },
                                        [_vm._v("Account Type is required")]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._l(_vm.seatPrice, function(list, sindex) {
                            return _vm.unit_type == "Seat"
                              ? _c(
                                  "div",
                                  {
                                    key: sindex,
                                    staticClass:
                                      "col-lg-12 col-12 override-padding mt-2"
                                  },
                                  [
                                    _c("div", { staticClass: "row" }, [
                                      _c("div", { staticClass: "col-3" }, [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: list.package_name,
                                              expression: "list.package_name"
                                            },
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value: "required",
                                              expression: "'required'"
                                            }
                                          ],
                                          staticClass:
                                            "col-12 input-text form-control seat-package-name",
                                          attrs: {
                                            placeholder: "Bundle Name",
                                            name: "package[" + sindex + "]",
                                            id: "'package_' + sindex",
                                            maxlength: "100"
                                          },
                                          domProps: {
                                            value: list.package_name
                                          },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                list,
                                                "package_name",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        })
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "col-3 p-0 pr-2" },
                                        [
                                          _c("b-form-select", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            staticClass:
                                              "input-text form-control col-12 seat-range-input",
                                            attrs: {
                                              options: _vm.seatOptions,
                                              name: "qty[" + sindex + "]",
                                              id: "qty_" + sindex
                                            },
                                            on: {
                                              change: function($event) {
                                                return _vm.checkSeatPriceQty(
                                                  sindex
                                                )
                                              }
                                            },
                                            model: {
                                              value: list.license_qty,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  list,
                                                  "license_qty",
                                                  $$v
                                                )
                                              },
                                              expression: "list.license_qty"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "col-3 p-0 pr-2" },
                                        [
                                          _vm._v(
                                            "\n                        $ "
                                          ),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  list.license_yearly_price,
                                                expression:
                                                  "list.license_yearly_price"
                                              },
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required|decimal:2",
                                                expression:
                                                  "'required|decimal:2'"
                                              }
                                            ],
                                            staticClass:
                                              "col-11 input-text form-control seat-range-price",
                                            attrs: {
                                              placeholder: "Yearly Price",
                                              name:
                                                "yearly_price[" + sindex + "]",
                                              id: "price1",
                                              maxlength: "8"
                                            },
                                            domProps: {
                                              value: list.license_yearly_price
                                            },
                                            on: {
                                              blur: function($event) {
                                                return _vm.formatSeatPrice(
                                                  $event,
                                                  sindex,
                                                  "yearly"
                                                )
                                              },
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  list,
                                                  "license_yearly_price",
                                                  $event.target.value
                                                )
                                              }
                                            }
                                          })
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "col-3 p-0",
                                          staticStyle: {
                                            "padding-right": "15px !important"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                        $ "
                                          ),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  list.license_monthly_price,
                                                expression:
                                                  "list.license_monthly_price"
                                              },
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required|decimal:2",
                                                expression:
                                                  "'required|decimal:2'"
                                              }
                                            ],
                                            staticClass:
                                              "col-11 input-text form-control seat-range-price",
                                            attrs: {
                                              placeholder: "Monthly Price",
                                              name:
                                                "monthly_price[" + sindex + "]",
                                              id: "price2",
                                              maxlength: "8"
                                            },
                                            domProps: {
                                              value: list.license_monthly_price
                                            },
                                            on: {
                                              blur: function($event) {
                                                return _vm.formatSeatPrice(
                                                  $event,
                                                  sindex,
                                                  "monthly"
                                                )
                                              },
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  list,
                                                  "license_monthly_price",
                                                  $event.target.value
                                                )
                                              }
                                            }
                                          })
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "row" }, [
                                      _vm.verrors.firstByRule(
                                        "package[" + sindex + "]",
                                        "required"
                                      )
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-3 margin-bottom-5 validate-warning-msg"
                                            },
                                            [_vm._v("Package Name is required")]
                                          )
                                        : _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-3 margin-bottom-5"
                                            },
                                            [_vm._v(" ")]
                                          ),
                                      _vm._v(" "),
                                      _vm.verrors.firstByRule(
                                        "qty[" + sindex + "]",
                                        "required"
                                      )
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-3 p-0 margin-bottom-5 validate-warning-msg"
                                            },
                                            [_vm._v("No of Seat is required")]
                                          )
                                        : _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-3 p-0 margin-bottom-5"
                                            },
                                            [_vm._v(" ")]
                                          ),
                                      _vm._v(" "),
                                      _vm.verrors.firstByRule(
                                        "yearly_price[" + sindex + "]",
                                        "required"
                                      )
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-3 margin-bottom-5 validate-warning-msg"
                                            },
                                            [_vm._v(" Price is required")]
                                          )
                                        : _vm.verrors.firstByRule(
                                            "yearly_price[" + sindex + "]",
                                            "decimal"
                                          )
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-3 margin-bottom-5 validate-warning-msg"
                                            },
                                            [
                                              _vm._v(
                                                "Price should be numeric and may contain 2 decimal points"
                                              )
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-3 margin-bottom-5"
                                            },
                                            [_vm._v(" ")]
                                          ),
                                      _vm._v(" "),
                                      _vm.verrors.firstByRule(
                                        "monthly_price[" + sindex + "]",
                                        "required"
                                      )
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-3 margin-bottom-5 validate-warning-msg"
                                            },
                                            [_vm._v("Price is required")]
                                          )
                                        : _vm.verrors.firstByRule(
                                            "monthly_price[" + sindex + "]",
                                            "decimal"
                                          )
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-3 margin-bottom-5 validate-warning-msg"
                                            },
                                            [
                                              _vm._v(
                                                "Price should be numeric and may contain 2 decimal points"
                                              )
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-3 margin-bottom-5"
                                            },
                                            [_vm._v(" ")]
                                          )
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "row" }, [
                                      _c("div", { staticClass: "col-3" }, [
                                        _vm._v(
                                          "\n                         \n                        "
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "col-3 p-0 pr-2" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: list.max_limit_qty,
                                                expression: "list.max_limit_qty"
                                              },
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required|numeric",
                                                expression: "'required|numeric'"
                                              }
                                            ],
                                            staticClass:
                                              "input-text form-control seat-range-package",
                                            attrs: {
                                              placeholder: "Max seat limit",
                                              name: "max_seat[" + sindex + "]",
                                              id: "'max_seat_' + sindex",
                                              maxlength: "5"
                                            },
                                            domProps: {
                                              value: list.max_limit_qty
                                            },
                                            on: {
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  list,
                                                  "max_limit_qty",
                                                  $event.target.value
                                                )
                                              }
                                            }
                                          })
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "col-3 p-0 pr-2" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: list.package_discount,
                                                expression:
                                                  "list.package_discount"
                                              },
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "numeric",
                                                expression: "'numeric'"
                                              }
                                            ],
                                            staticClass:
                                              "input-text form-control seat-range-package",
                                            attrs: {
                                              placeholder: "Discount Percent",
                                              name:
                                                "package_discount[" +
                                                sindex +
                                                "]",
                                              id:
                                                "'package_discount_' + sindex",
                                              maxlength: "5"
                                            },
                                            domProps: {
                                              value: list.package_discount
                                            },
                                            on: {
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  list,
                                                  "package_discount",
                                                  $event.target.value
                                                )
                                              }
                                            }
                                          })
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "col-3 p-0",
                                          staticStyle: {
                                            "padding-right": "15px !important"
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "delete-icon" },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "fa fa-window-close cursor-pointer",
                                                attrs: {
                                                  "aria-hidden": "true"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.removeSeat(
                                                      sindex
                                                    )
                                                  }
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "row" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-3 p-0 margin-bottom-5"
                                        },
                                        [_vm._v(" ")]
                                      ),
                                      _vm._v(" "),
                                      _vm.verrors.firstByRule(
                                        "max_seat[" + sindex + "]",
                                        "required"
                                      )
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-3 p-0 margin-bottom-5 validate-warning-msg"
                                            },
                                            [
                                              _vm._v(
                                                "Max seat limit is required"
                                              )
                                            ]
                                          )
                                        : _vm.verrors.firstByRule(
                                            "max_seat[" + sindex + "]",
                                            "numeric"
                                          )
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-3 p-0 margin-bottom-5 validate-warning-msg"
                                            },
                                            [
                                              _vm._v(
                                                "Max seat limit should be numeric"
                                              )
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-3 margin-bottom-5"
                                            },
                                            [_vm._v(" ")]
                                          ),
                                      _vm._v(" "),
                                      _vm.verrors.firstByRule(
                                        "package_discount[" + sindex + "]",
                                        "numeric"
                                      )
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-3 p-0 margin-bottom-5 validate-warning-msg"
                                            },
                                            [
                                              _vm._v(
                                                "Discount should be numeric"
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "col-3 margin-bottom-5"
                                        },
                                        [_vm._v(" ")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "col-3 margin-bottom-5"
                                        },
                                        [_vm._v(" ")]
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e()
                          }),
                          _vm._v(" "),
                          _c("div", { staticStyle: { clear: "both" } }),
                          _vm._v(" "),
                          _vm.unit_type == "Seat"
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "mb-2 float-right price-range-wrapper",
                                  staticStyle: { cursor: "pointer" },
                                  on: {
                                    click: function($event) {
                                      return _vm.addMoreSeat()
                                    }
                                  }
                                },
                                [_vm._v(" + Add More Bundles")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticStyle: { clear: "both" } }),
                          _vm._v(" "),
                          _vm.unit_type == "Seat"
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "mt-3 mb-3 py-2 px-3 subscription_box rounded shadow"
                                },
                                [
                                  _c("div", { staticClass: "row" }, [
                                    _c(
                                      "div",
                                      { staticClass: "col-12 pr-0 bold pb-3" },
                                      [
                                        _vm._v(
                                          "\n                          Additional Seat Price\n                        "
                                        )
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "row" }, [
                                    _c(
                                      "div",
                                      { staticClass: "col-2 pr-0 pt-2" },
                                      [
                                        _vm._v(
                                          "\n                            Yearly:\n                        "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "col-4 pl-0" }, [
                                      _vm._v("\n                        $ "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.additional_seat_price_yearly,
                                            expression:
                                              "additional_seat_price_yearly"
                                          },
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: "required|decimal:2",
                                            expression: "'required|decimal:2'"
                                          }
                                        ],
                                        staticClass:
                                          "col-11 input-text form-control license-range-price",
                                        staticStyle: { "max-width": "78%" },
                                        attrs: {
                                          placeholder: "Price",
                                          name: "yearly_seat_price",
                                          maxlength: "8"
                                        },
                                        domProps: {
                                          value:
                                            _vm.additional_seat_price_yearly
                                        },
                                        on: {
                                          blur: function($event) {
                                            return _vm.formatSeatAdditionalPrice(
                                              $event,
                                              "add",
                                              "yearly"
                                            )
                                          },
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.additional_seat_price_yearly =
                                              $event.target.value
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _vm.verrors.firstByRule(
                                        "yearly_seat_price",
                                        "required"
                                      )
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "text-left margin-bottom-5 validate-warning-msg"
                                            },
                                            [_vm._v("Price is required")]
                                          )
                                        : _vm.verrors.firstByRule(
                                            "yearly_seat_price",
                                            "decimal"
                                          )
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "text-left margin-bottom-5 validate-warning-msg"
                                            },
                                            [
                                              _vm._v(
                                                "Price should be numeric and may contain 2 decimal points"
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-2 pr-0 pt-2" },
                                      [
                                        _vm._v(
                                          "\n                            Monthly:\n                        "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "col-4 pl-0" }, [
                                      _vm._v("\n                        $ "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.additional_seat_price_monthly,
                                            expression:
                                              "additional_seat_price_monthly"
                                          },
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: "required|decimal:2",
                                            expression: "'required|decimal:2'"
                                          }
                                        ],
                                        staticClass:
                                          "col-11 input-text form-control license-range-price",
                                        staticStyle: { "max-width": "78%" },
                                        attrs: {
                                          placeholder: "Price",
                                          name: "monthly_seat_price",
                                          maxlength: "8"
                                        },
                                        domProps: {
                                          value:
                                            _vm.additional_seat_price_monthly
                                        },
                                        on: {
                                          blur: function($event) {
                                            return _vm.formatSeatAdditionalPrice(
                                              $event,
                                              "add",
                                              "monthly"
                                            )
                                          },
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.additional_seat_price_monthly =
                                              $event.target.value
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _vm.verrors.firstByRule(
                                        "monthly_seat_price",
                                        "required"
                                      )
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "text-left margin-bottom-5 validate-warning-msg"
                                            },
                                            [_vm._v("Price is required")]
                                          )
                                        : _vm.verrors.firstByRule(
                                            "monthly_seat_price",
                                            "decimal"
                                          )
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "text-left margin-bottom-5 validate-warning-msg"
                                            },
                                            [
                                              _vm._v(
                                                "Price should be numeric and may contain 2 decimal points"
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ])
                                  ])
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "mt-2 col-lg-12 col-12 override-padding"
                            },
                            [
                              _vm.unit_type != ""
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "search-padd",
                                      attrs: { id: "purchase-type-wrapper" }
                                    },
                                    [
                                      _c("multiselect", {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: "required",
                                            expression: "'required'"
                                          }
                                        ],
                                        attrs: {
                                          options: _vm.affiliate_options,
                                          "track-by": "name",
                                          label: "name",
                                          placeholder: "Select Affiliates...",
                                          multiple: true,
                                          "close-on-select": false,
                                          "show-labels": false,
                                          name: "affiliate",
                                          id: "affiliate"
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "selection",
                                            fn: function(ref) {
                                              var values = ref.values
                                              var search = ref.search
                                              var isOpen = ref.isOpen
                                              return [
                                                values.length && !isOpen
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "multiselect__single"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            values.length
                                                          ) + " selected"
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            }
                                          }
                                        ]),
                                        model: {
                                          value: _vm.affiliate_selected,
                                          callback: function($$v) {
                                            _vm.affiliate_selected = $$v
                                          },
                                          expression: "affiliate_selected"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _vm.verrors.firstByRule(
                                        "affiliate",
                                        "required"
                                      )
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "margin-bottom-5 validate-warning-msg"
                                            },
                                            [_vm._v("Affiliate is required")]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "margin-bottom-10",
                            staticStyle: { clear: "both" }
                          }),
                          _vm._v(" "),
                          _vm.unit_type == "License"
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "col-lg-12 col-12 override-padding"
                                },
                                [
                                  _c("b-form-select", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required",
                                        expression: "'required'"
                                      }
                                    ],
                                    staticClass: "input-text",
                                    attrs: {
                                      options: _vm.validityDurationOptions,
                                      name: "Validity Duration"
                                    },
                                    model: {
                                      value: _vm.package_validity_duration,
                                      callback: function($$v) {
                                        _vm.package_validity_duration = $$v
                                      },
                                      expression: "package_validity_duration"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _vm.verrors.firstByRule(
                                    "Validity Duration",
                                    "required"
                                  )
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "margin-bottom-5 validate-warning-msg"
                                        },
                                        [
                                          _vm._v(
                                            "Validity Duration is required"
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.unit_type == "Seat"
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "col-lg-12 col-12 override-padding"
                                },
                                [
                                  _c("b-form-select", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required",
                                        expression: "'required'"
                                      }
                                    ],
                                    staticClass: "input-text",
                                    attrs: {
                                      options: _vm.seatValidityDurationOptions,
                                      name: "Validity Duration"
                                    },
                                    model: {
                                      value: _vm.package_validity_duration,
                                      callback: function($$v) {
                                        _vm.package_validity_duration = $$v
                                      },
                                      expression: "package_validity_duration"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _vm.verrors.firstByRule(
                                    "Validity Duration",
                                    "required"
                                  )
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "margin-bottom-5 validate-warning-msg"
                                        },
                                        [
                                          _vm._v(
                                            "Validity Duration is required"
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.unit_type == "License" || _vm.unit_type == "Seat"
                            ? _c("div", {
                                staticClass: "margin-bottom-10",
                                staticStyle: { clear: "both" }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.unit_type != ""
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "col-lg-12 col-12 override-padding"
                                },
                                [
                                  _c("b-form-select", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required",
                                        expression: "'required'"
                                      }
                                    ],
                                    staticClass: "input-text",
                                    attrs: {
                                      options: _vm.packageStatusOptions,
                                      name: "Status"
                                    },
                                    model: {
                                      value: _vm.package_is_active,
                                      callback: function($$v) {
                                        _vm.package_is_active = $$v
                                      },
                                      expression: "package_is_active"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _vm.verrors.firstByRule("Status", "required")
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "margin-bottom-5 validate-warning-msg"
                                        },
                                        [_vm._v("Status is required")]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.unit_type == "License" &&
                          _vm.package_is_active == "1"
                            ? _c(
                                "div",
                                { staticClass: "license-criteria-wrapper" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "license-criteria-heading" },
                                    [_vm._v("License Redistribution Criteria")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-lg-12 col-12 override-padding"
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.probation_window,
                                            expression: "probation_window"
                                          },
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: "required|numeric",
                                            expression: "'required|numeric'"
                                          }
                                        ],
                                        staticClass:
                                          "input-text form-control license-range-input",
                                        attrs: {
                                          placeholder: "Probation",
                                          name: "Probation Window",
                                          maxlength: "3"
                                        },
                                        domProps: {
                                          value: _vm.probation_window
                                        },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.probation_window =
                                              $event.target.value
                                          }
                                        }
                                      }),
                                      _vm._v(
                                        " days \n                            "
                                      ),
                                      _c("span", {
                                        staticStyle: { "margin-right": "40px" }
                                      }),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.reassign_window,
                                            expression: "reassign_window"
                                          },
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: "required|numeric",
                                            expression: "'required|numeric'"
                                          }
                                        ],
                                        staticClass:
                                          "input-text form-control license-range-input",
                                        attrs: {
                                          placeholder: "Reassign",
                                          name: "Reassign Window",
                                          maxlength: "3"
                                        },
                                        domProps: {
                                          value: _vm.reassign_window
                                        },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.reassign_window =
                                              $event.target.value
                                          }
                                        }
                                      }),
                                      _vm._v(
                                        " days \n                            "
                                      ),
                                      _c("span", {
                                        staticStyle: { "margin-right": "30px" }
                                      }),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.no_of_reassign,
                                            expression: "no_of_reassign"
                                          },
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: "required|numeric",
                                            expression: "'required|numeric'"
                                          }
                                        ],
                                        staticClass:
                                          "input-text form-control license-range-input",
                                        attrs: {
                                          placeholder: "#",
                                          name: "No Of Reassign",
                                          maxlength: "1"
                                        },
                                        domProps: { value: _vm.no_of_reassign },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.no_of_reassign =
                                              $event.target.value
                                          }
                                        }
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-lg-12 col-12 override-padding license-criteria-label"
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "license-criteria-label"
                                        },
                                        [_vm._v("Probation Window ")]
                                      ),
                                      _vm._v(" "),
                                      _c("span", {
                                        staticStyle: { "margin-right": "60px" }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "license-criteria-label"
                                        },
                                        [_vm._v("Reassign Window ")]
                                      ),
                                      _vm._v(" "),
                                      _c("span", {
                                        staticStyle: { "margin-right": "40px" }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "license-criteria-label"
                                        },
                                        [_vm._v("# of Reassigns")]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass: "margin-bottom-10",
                                    staticStyle: { clear: "both" }
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "row" }, [
                                    _vm.verrors.firstByRule(
                                      "Probation Window",
                                      "required"
                                    )
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-4 margin-bottom-5 validate-warning-msg"
                                          },
                                          [
                                            _vm._v(
                                              "Probation Window is required"
                                            )
                                          ]
                                        )
                                      : _vm.verrors.firstByRule(
                                          "Probation Window",
                                          "numeric"
                                        )
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-4 margin-bottom-5 validate-warning-msg"
                                          },
                                          [
                                            _vm._v(
                                              "Probation Window should be numeric"
                                            )
                                          ]
                                        )
                                      : _c(
                                          "div",
                                          {
                                            staticClass: "col-4 margin-bottom-5"
                                          },
                                          [_vm._v(" ")]
                                        ),
                                    _vm._v(" "),
                                    _vm.verrors.firstByRule(
                                      "Reassign Window",
                                      "required"
                                    )
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-4 margin-bottom-5 validate-warning-msg"
                                          },
                                          [
                                            _vm._v(
                                              "Reassign Window is required"
                                            )
                                          ]
                                        )
                                      : _vm.verrors.firstByRule(
                                          "Reassign Window",
                                          "numeric"
                                        )
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-4 margin-bottom-5 validate-warning-msg"
                                          },
                                          [
                                            _vm._v(
                                              "Reassign Window should be numeric"
                                            )
                                          ]
                                        )
                                      : _c(
                                          "div",
                                          {
                                            staticClass: "col-4 margin-bottom-5"
                                          },
                                          [_vm._v(" ")]
                                        ),
                                    _vm._v(" "),
                                    _vm.verrors.firstByRule(
                                      "No Of Reassign",
                                      "required"
                                    )
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-4 margin-bottom-5 validate-warning-msg"
                                          },
                                          [
                                            _vm._v(
                                              " No Of Reassign is required"
                                            )
                                          ]
                                        )
                                      : _vm.verrors.firstByRule(
                                          "No Of Reassign",
                                          "numeric"
                                        )
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-4 margin-bottom-5 validate-warning-msg"
                                          },
                                          [
                                            _vm._v(
                                              "No Of Reassign should be numeric"
                                            )
                                          ]
                                        )
                                      : _c(
                                          "div",
                                          {
                                            staticClass: "col-4 margin-bottom-5"
                                          },
                                          [_vm._v(" ")]
                                        )
                                  ])
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "margin-bottom-10",
                            staticStyle: { clear: "both" }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-12 override-padding" },
                            [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-red col-3 float-left input-height-25",
                                  on: {
                                    click: function($event) {
                                      return _vm.createPackageAction()
                                    }
                                  }
                                },
                                [_c("b", [_vm._v("Create")])]
                              )
                            ]
                          )
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "col-3 override-padding",
                    attrs: { slot: "footer" },
                    slot: "footer"
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "EditSubscriptionModal",
                {
                  attrs: {
                    isModalVisible: _vm.isEditModalVisible,
                    editId: _vm.editId
                  },
                  on: {
                    close: function($event) {
                      _vm.isEditModalVisible = false
                    }
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "sub-heading",
                      attrs: { slot: "header" },
                      slot: "header"
                    },
                    [_c("h3", [_vm._v("Edit Purchase Type")])]
                  ),
                  _vm._v(" "),
                  _vm.isEditModalVisible === true
                    ? _c(
                        "div",
                        { attrs: { slot: "body" }, slot: "body" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "col-lg-12 col-12 override-padding"
                            },
                            [
                              _c("b-form-select", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                staticClass: "input-text",
                                attrs: {
                                  options: _vm.editUnitTypeOptions,
                                  name: "Unit Type"
                                },
                                model: {
                                  value: _vm.edit_unit_type,
                                  callback: function($$v) {
                                    _vm.edit_unit_type = $$v
                                  },
                                  expression: "edit_unit_type"
                                }
                              }),
                              _vm._v(" "),
                              _vm.verrors.firstByRule("Unit Type", "required")
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "margin-bottom-5 validate-warning-msg"
                                    },
                                    [_vm._v("Unit Type is required")]
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "margin-bottom-10",
                            staticStyle: { clear: "both" }
                          }),
                          _vm._v(" "),
                          _vm.edit_unit_type == "License"
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "col-lg-12 col-12 override-padding"
                                },
                                [
                                  _c("b-form-select", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required",
                                        expression: "'required'"
                                      }
                                    ],
                                    staticClass: "input-text",
                                    attrs: {
                                      options: _vm.licenseTypeOptions,
                                      name: "License Type"
                                    },
                                    model: {
                                      value: _vm.edit_license_type,
                                      callback: function($$v) {
                                        _vm.edit_license_type = $$v
                                      },
                                      expression: "edit_license_type"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _vm.verrors.firstByRule(
                                    "License Type",
                                    "required"
                                  )
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "margin-bottom-5 validate-warning-msg"
                                        },
                                        [_vm._v("License Type is required")]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "margin-bottom-10",
                            staticStyle: { clear: "both" }
                          }),
                          _vm._v(" "),
                          _vm.edit_unit_type == "License" ||
                          _vm.edit_unit_type == "Seat"
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "col-lg-12 col-12 override-padding"
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.edit_license_name,
                                        expression: "edit_license_name"
                                      },
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required",
                                        expression: "'required'"
                                      }
                                    ],
                                    staticClass:
                                      "col-12 input-text form-control",
                                    attrs: {
                                      placeholder: "License Name",
                                      name: "License Name",
                                      maxlength: "150"
                                    },
                                    domProps: { value: _vm.edit_license_name },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.edit_license_name =
                                          $event.target.value
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _vm.verrors.firstByRule(
                                    "License Name",
                                    "required"
                                  )
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "margin-bottom-5 validate-warning-msg"
                                        },
                                        [_vm._v("License Name is required")]
                                      )
                                    : _vm._e()
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "margin-bottom-10",
                            staticStyle: { clear: "both" }
                          }),
                          _vm._v(" "),
                          _vm.edit_unit_type == "One Time Purchase"
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "col-lg-12 col-12 override-padding"
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.edit_price_onetime,
                                        expression: "edit_price_onetime"
                                      },
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required",
                                        expression: "'required'"
                                      }
                                    ],
                                    staticClass:
                                      "col-12 input-text form-control",
                                    attrs: {
                                      placeholder: "Price",
                                      name: "Price",
                                      maxlength: "8"
                                    },
                                    domProps: { value: _vm.edit_price_onetime },
                                    on: {
                                      blur: function($event) {
                                        return _vm.formatOneTimePrice(
                                          $event,
                                          "edit"
                                        )
                                      },
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.edit_price_onetime =
                                          $event.target.value
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _vm.verrors.firstByRule("Price", "required")
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "margin-bottom-5 validate-warning-msg"
                                        },
                                        [_vm._v("Price is required")]
                                      )
                                    : _vm._e()
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "margin-bottom-10",
                            staticStyle: { clear: "both" }
                          }),
                          _vm._v(" "),
                          _vm.edit_unit_type == "License" &&
                          _vm.edit_license_type == "Bundle License"
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "col-lg-12 col-12 override-padding"
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "col-8 p-0 float-left" },
                                    [
                                      _c("div", { staticClass: "col-12 p-0" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "col-7 p-0 float-left",
                                            staticStyle: { "margin-top": "5px" }
                                          },
                                          [
                                            _vm._v(
                                              "\n                            Minimum License: \n                          "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "col-5 p-0 float-left"
                                          },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.edit_license_qty,
                                                  expression: "edit_license_qty"
                                                },
                                                {
                                                  name: "validate",
                                                  rawName: "v-validate",
                                                  value: "required|numeric",
                                                  expression:
                                                    "'required|numeric'"
                                                }
                                              ],
                                              staticClass:
                                                "col-12 input-text form-control",
                                              attrs: {
                                                placeholder: "Quantity",
                                                name: "License Quantity",
                                                maxlength: "2"
                                              },
                                              domProps: {
                                                value: _vm.edit_license_qty
                                              },
                                              on: {
                                                input: function($event) {
                                                  if ($event.target.composing) {
                                                    return
                                                  }
                                                  _vm.edit_license_qty =
                                                    $event.target.value
                                                }
                                              }
                                            }),
                                            _vm._v(" "),
                                            _vm.verrors.firstByRule(
                                              "License Quantity",
                                              "required"
                                            )
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "margin-bottom-5 validate-warning-msg"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Minimum Quantity is required"
                                                    )
                                                  ]
                                                )
                                              : _vm.verrors.firstByRule(
                                                  "License Quantity",
                                                  "numeric"
                                                )
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "margin-bottom-5 validate-warning-msg"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Minimum Quantity should be numeric"
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticClass: "margin-bottom-20",
                                          staticStyle: { clear: "both" }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-12 p-0" },
                                          [
                                            _vm._v(
                                              "\n                            Price per license (After Bundle):\n                          "
                                            )
                                          ]
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "col-4 p-0 float-left",
                                      staticStyle: {
                                        "padding-left": "15px !important"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-12 p-0 text-align-right"
                                        },
                                        [
                                          _vm._v(
                                            "\n                          $ "
                                          ),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.edit_bundle_price,
                                                expression: "edit_bundle_price"
                                              },
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required|decimal:2",
                                                expression:
                                                  "'required|decimal:2'"
                                              }
                                            ],
                                            staticClass:
                                              "col-10 input-text form-control license-range-price",
                                            attrs: {
                                              placeholder: "Price",
                                              name: "Price Bundle",
                                              maxlength: "8"
                                            },
                                            domProps: {
                                              value: _vm.edit_bundle_price
                                            },
                                            on: {
                                              blur: function($event) {
                                                return _vm.formatBundlePrice(
                                                  $event,
                                                  "edit"
                                                )
                                              },
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.edit_bundle_price =
                                                  $event.target.value
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _vm.verrors.firstByRule(
                                            "Price Bundle",
                                            "required"
                                          )
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "text-left margin-bottom-5 validate-warning-msg"
                                                },
                                                [
                                                  _vm._v(
                                                    "Bundle Price is required"
                                                  )
                                                ]
                                              )
                                            : _vm.verrors.firstByRule(
                                                "Price Bundle",
                                                "decimal"
                                              )
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "text-left margin-bottom-5 validate-warning-msg"
                                                },
                                                [
                                                  _vm._v(
                                                    "Price should be numeric and may contain 2 decimal points"
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-12 p-0 text-align-right",
                                          staticStyle: { "margin-top": "10px" }
                                        },
                                        [
                                          _vm._v(
                                            "\n                          $ "
                                          ),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.edit_price_after_bundle,
                                                expression:
                                                  "edit_price_after_bundle"
                                              },
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required||decimal:2",
                                                expression:
                                                  "'required||decimal:2'"
                                              }
                                            ],
                                            staticClass:
                                              "col-10 input-text form-control  license-range-price",
                                            attrs: {
                                              placeholder: "Price",
                                              name: "Price After Bundle",
                                              maxlength: "8"
                                            },
                                            domProps: {
                                              value: _vm.edit_price_after_bundle
                                            },
                                            on: {
                                              blur: function($event) {
                                                return _vm.formatPriceAfterBundle(
                                                  $event,
                                                  "edit"
                                                )
                                              },
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.edit_price_after_bundle =
                                                  $event.target.value
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _vm.verrors.firstByRule(
                                            "Price After Bundle",
                                            "required"
                                          )
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "text-left margin-bottom-5 validate-warning-msg"
                                                },
                                                [_vm._v("Price is required")]
                                              )
                                            : _vm.verrors.firstByRule(
                                                "Price After Bundle",
                                                "decimal"
                                              )
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "text-left margin-bottom-5 validate-warning-msg"
                                                },
                                                [
                                                  _vm._v(
                                                    "Price should be numeric and may contain 2 decimal points"
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "margin-bottom-10",
                            staticStyle: { clear: "both" }
                          }),
                          _vm._v(" "),
                          _vm._l(_vm.editPriceTier, function(list, pindex) {
                            return _vm.edit_unit_type == "License" &&
                              _vm.edit_license_type == "Normal License"
                              ? _c(
                                  "div",
                                  {
                                    key: pindex,
                                    staticClass:
                                      "col-lg-12 col-12 override-padding"
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: list.license_id,
                                          expression: "list.license_id"
                                        }
                                      ],
                                      attrs: {
                                        type: "hidden",
                                        name: "licenseId[" + pindex + "]"
                                      },
                                      domProps: { value: list.license_id },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            list,
                                            "license_id",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: list.license_from,
                                          expression: "list.license_from"
                                        },
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "required|numeric",
                                          expression: "'required|numeric'"
                                        }
                                      ],
                                      staticClass:
                                        "input-text form-control license-range-input",
                                      attrs: {
                                        placeholder: "",
                                        name: "rangeFrom[" + pindex + "]",
                                        maxlength: "4"
                                      },
                                      domProps: { value: list.license_from },
                                      on: {
                                        blur: function($event) {
                                          return _vm.editCheckPriceRangeNumbers(
                                            pindex,
                                            "From"
                                          )
                                        },
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            list,
                                            "license_from",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(
                                      "\n                                      ―    \n                                "
                                    ),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: list.license_to,
                                          expression: "list.license_to"
                                        },
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "required|numeric",
                                          expression: "'required|numeric'"
                                        }
                                      ],
                                      staticClass:
                                        "input-text form-control license-range-input",
                                      attrs: {
                                        placeholder: "",
                                        name: "rangeTo[" + pindex + "]",
                                        maxlength: "4"
                                      },
                                      domProps: { value: list.license_to },
                                      on: {
                                        blur: function($event) {
                                          return _vm.editCheckPriceRangeNumbers(
                                            pindex,
                                            "To"
                                          )
                                        },
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            list,
                                            "license_to",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(
                                      "       \n                                $ "
                                    ),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: list.license_price,
                                          expression: "list.license_price"
                                        },
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "required|decimal:2",
                                          expression: "'required|decimal:2'"
                                        }
                                      ],
                                      staticClass:
                                        "col-4 input-text form-control license-range-price",
                                      attrs: {
                                        placeholder: "Price",
                                        name: "price[" + pindex + "]",
                                        maxlength: "8"
                                      },
                                      domProps: { value: list.license_price },
                                      on: {
                                        blur: function($event) {
                                          return _vm.formatEditPrice(
                                            $event,
                                            pindex
                                          )
                                        },
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            list,
                                            "license_price",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "row" }, [
                                      _vm.verrors.firstByRule(
                                        "rangeFrom[" + pindex + "]",
                                        "required"
                                      )
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-4 margin-bottom-5 validate-warning-msg"
                                            },
                                            [_vm._v("Range From is required")]
                                          )
                                        : _vm.verrors.firstByRule(
                                            "rangeFrom[" + pindex + "]",
                                            "numeric"
                                          )
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-4 margin-bottom-5 validate-warning-msg"
                                            },
                                            [
                                              _vm._v(
                                                "Range From should be numeric"
                                              )
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-4 margin-bottom-5"
                                            },
                                            [_vm._v(" ")]
                                          ),
                                      _vm._v(" "),
                                      _vm.verrors.firstByRule(
                                        "rangeTo[" + pindex + "]",
                                        "required"
                                      )
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-4 margin-bottom-5 validate-warning-msg"
                                            },
                                            [_vm._v("Range To is required")]
                                          )
                                        : _vm.verrors.firstByRule(
                                            "rangeTo[" + pindex + "]",
                                            "numeric"
                                          )
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-4 margin-bottom-5 validate-warning-msg"
                                            },
                                            [
                                              _vm._v(
                                                "Range To should be numeric"
                                              )
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-4 margin-bottom-5"
                                            },
                                            [_vm._v(" ")]
                                          ),
                                      _vm._v(" "),
                                      _vm.verrors.firstByRule(
                                        "price[" + pindex + "]",
                                        "required"
                                      )
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-4 margin-bottom-5 validate-warning-msg"
                                            },
                                            [_vm._v(" Price is required")]
                                          )
                                        : _vm.verrors.firstByRule(
                                            "price[" + pindex + "]",
                                            "decimal"
                                          )
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-4 margin-bottom-5 validate-warning-msg"
                                            },
                                            [
                                              _vm._v(
                                                "Price should be numeric and may contain 2 decimal points"
                                              )
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-4 margin-bottom-5"
                                            },
                                            [_vm._v(" ")]
                                          )
                                    ])
                                  ]
                                )
                              : _vm._e()
                          }),
                          _vm._v(" "),
                          _vm.edit_unit_type == "License" &&
                          _vm.edit_license_type == "Normal License"
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "float-right price-range-wrapper",
                                  on: {
                                    click: function($event) {
                                      return _vm.addMorePriceTierOfEdit()
                                    }
                                  }
                                },
                                [_vm._v(" + Add License Price Range")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "margin-bottom-10",
                            staticStyle: { clear: "both" }
                          }),
                          _vm._v(" "),
                          _vm.edit_unit_type == "One Time Purchase"
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "col-lg-12 col-12 override-padding"
                                },
                                [
                                  _c("b-form-select", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required",
                                        expression: "'required'"
                                      }
                                    ],
                                    staticClass: "input-text",
                                    attrs: {
                                      options: _vm.accountTypeOptions,
                                      name: "Account Type"
                                    },
                                    model: {
                                      value: _vm.edit_account_type,
                                      callback: function($$v) {
                                        _vm.edit_account_type = $$v
                                      },
                                      expression: "edit_account_type"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _vm.verrors.firstByRule(
                                    "Account Type",
                                    "required"
                                  )
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "margin-bottom-5 validate-warning-msg"
                                        },
                                        [_vm._v("Account Type is required")]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "margin-bottom-10",
                            staticStyle: { clear: "both" }
                          }),
                          _vm._v(" "),
                          _vm._l(_vm.editseatPrice, function(list, sindex) {
                            return _vm.edit_unit_type == "Seat"
                              ? _c(
                                  "div",
                                  {
                                    key: sindex,
                                    staticClass:
                                      "col-lg-12 col-12 override-padding mt-2"
                                  },
                                  [
                                    _c("div", { staticClass: "row" }, [
                                      _c("div", { staticClass: "col-3" }, [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: list.package_name,
                                              expression: "list.package_name"
                                            },
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value: "required",
                                              expression: "'required'"
                                            }
                                          ],
                                          staticClass:
                                            "col-12 input-text form-control seat-package-name",
                                          attrs: {
                                            placeholder: "Package Name",
                                            name: "package[" + sindex + "]",
                                            id: "'package_' + sindex",
                                            maxlength: "100"
                                          },
                                          domProps: {
                                            value: list.package_name
                                          },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                list,
                                                "package_name",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        })
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "col-3 p-0 pr-2" },
                                        [
                                          _c("b-form-select", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            staticClass:
                                              "input-text form-control col-12 seat-range-input",
                                            attrs: {
                                              options: _vm.seatOptions,
                                              name: "qty[" + sindex + "]",
                                              id: "qty_" + sindex
                                            },
                                            on: {
                                              change: function($event) {
                                                return _vm.checkEditSeatPriceQty(
                                                  sindex
                                                )
                                              }
                                            },
                                            model: {
                                              value: list.license_qty,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  list,
                                                  "license_qty",
                                                  $$v
                                                )
                                              },
                                              expression: "list.license_qty"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "col-3 p-0 pr-2" },
                                        [
                                          _vm._v(
                                            "\n                        $ "
                                          ),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  list.license_yearly_price,
                                                expression:
                                                  "list.license_yearly_price"
                                              },
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required|decimal:2",
                                                expression:
                                                  "'required|decimal:2'"
                                              }
                                            ],
                                            staticClass:
                                              "col-11 input-text form-control seat-range-price",
                                            attrs: {
                                              placeholder: "Yearly Price",
                                              name:
                                                "yearly_price[" + sindex + "]",
                                              id: "price1",
                                              maxlength: "8"
                                            },
                                            domProps: {
                                              value: list.license_yearly_price
                                            },
                                            on: {
                                              blur: function($event) {
                                                return _vm.formatEditSeatPrice(
                                                  $event,
                                                  sindex,
                                                  "yearly"
                                                )
                                              },
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  list,
                                                  "license_yearly_price",
                                                  $event.target.value
                                                )
                                              }
                                            }
                                          })
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "col-3 p-0",
                                          staticStyle: {
                                            "padding-right": "15px !important"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                        $ "
                                          ),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  list.license_monthly_price,
                                                expression:
                                                  "list.license_monthly_price"
                                              },
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required|decimal:2",
                                                expression:
                                                  "'required|decimal:2'"
                                              }
                                            ],
                                            staticClass:
                                              "col-11 input-text form-control seat-range-price",
                                            attrs: {
                                              placeholder: "Monthly Price",
                                              name:
                                                "monthly_price[" + sindex + "]",
                                              id: "price2",
                                              maxlength: "8"
                                            },
                                            domProps: {
                                              value: list.license_monthly_price
                                            },
                                            on: {
                                              blur: function($event) {
                                                return _vm.formatEditSeatPrice(
                                                  $event,
                                                  sindex,
                                                  "monthly"
                                                )
                                              },
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  list,
                                                  "license_monthly_price",
                                                  $event.target.value
                                                )
                                              }
                                            }
                                          })
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "row" }, [
                                      _vm.verrors.firstByRule(
                                        "package[" + sindex + "]",
                                        "required"
                                      )
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-3 margin-bottom-5 validate-warning-msg"
                                            },
                                            [_vm._v("Bundle Name is required")]
                                          )
                                        : _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-3 margin-bottom-5"
                                            },
                                            [_vm._v(" ")]
                                          ),
                                      _vm._v(" "),
                                      _vm.verrors.firstByRule(
                                        "qty[" + sindex + "]",
                                        "required"
                                      )
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-3 p-0 margin-bottom-5 validate-warning-msg"
                                            },
                                            [_vm._v("No of Seat is required")]
                                          )
                                        : _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-3 p-0 margin-bottom-5"
                                            },
                                            [_vm._v(" ")]
                                          ),
                                      _vm._v(" "),
                                      _vm.verrors.firstByRule(
                                        "yearly_price[" + sindex + "]",
                                        "required"
                                      )
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-3 margin-bottom-5 validate-warning-msg"
                                            },
                                            [_vm._v(" Price is required")]
                                          )
                                        : _vm.verrors.firstByRule(
                                            "yearly_price[" + sindex + "]",
                                            "decimal"
                                          )
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-3 margin-bottom-5 validate-warning-msg"
                                            },
                                            [
                                              _vm._v(
                                                "Price should be numeric and may contain 2 decimal points"
                                              )
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-3 margin-bottom-5"
                                            },
                                            [_vm._v(" ")]
                                          ),
                                      _vm._v(" "),
                                      _vm.verrors.firstByRule(
                                        "monthly_price[" + sindex + "]",
                                        "required"
                                      )
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-3 margin-bottom-5 validate-warning-msg"
                                            },
                                            [_vm._v("Price is required")]
                                          )
                                        : _vm.verrors.firstByRule(
                                            "monthly_price[" + sindex + "]",
                                            "decimal"
                                          )
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-3 margin-bottom-5 validate-warning-msg"
                                            },
                                            [
                                              _vm._v(
                                                "Price should be numeric and may contain 2 decimal points"
                                              )
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-3 margin-bottom-5"
                                            },
                                            [_vm._v(" ")]
                                          )
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "row" }, [
                                      _c("div", { staticClass: "col-3" }, [
                                        _vm._v(
                                          "\n                         \n                        "
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "col-3 p-0 pr-2" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: list.max_limit_qty,
                                                expression: "list.max_limit_qty"
                                              },
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required|numeric",
                                                expression: "'required|numeric'"
                                              }
                                            ],
                                            staticClass:
                                              "input-text form-control seat-range-package",
                                            attrs: {
                                              placeholder: "Max seat limit",
                                              name: "max_seat[" + sindex + "]",
                                              id: "'max_seat_' + sindex",
                                              maxlength: "5"
                                            },
                                            domProps: {
                                              value: list.max_limit_qty
                                            },
                                            on: {
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  list,
                                                  "max_limit_qty",
                                                  $event.target.value
                                                )
                                              }
                                            }
                                          })
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "col-3 p-0 pr-2" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: list.package_discount,
                                                expression:
                                                  "list.package_discount"
                                              },
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "numeric",
                                                expression: "'numeric'"
                                              }
                                            ],
                                            staticClass:
                                              "input-text form-control seat-range-package",
                                            attrs: {
                                              placeholder: "Discount Percent",
                                              name:
                                                "package_discount[" +
                                                sindex +
                                                "]",
                                              id:
                                                "'package_discount_' + sindex",
                                              maxlength: "5"
                                            },
                                            domProps: {
                                              value: list.package_discount
                                            },
                                            on: {
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  list,
                                                  "package_discount",
                                                  $event.target.value
                                                )
                                              }
                                            }
                                          })
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "col-3 p-0",
                                          staticStyle: {
                                            "padding-right": "15px !important"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                           \n                        "
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "row" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-3 p-0 margin-bottom-5"
                                        },
                                        [_vm._v(" ")]
                                      ),
                                      _vm._v(" "),
                                      _vm.verrors.firstByRule(
                                        "max_seat[" + sindex + "]",
                                        "required"
                                      )
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-3 p-0 margin-bottom-5 validate-warning-msg"
                                            },
                                            [
                                              _vm._v(
                                                "Max seat limit is required"
                                              )
                                            ]
                                          )
                                        : _vm.verrors.firstByRule(
                                            "max_seat[" + sindex + "]",
                                            "numeric"
                                          )
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-3 p-0 margin-bottom-5 validate-warning-msg"
                                            },
                                            [
                                              _vm._v(
                                                "Max seat limit should be numeric"
                                              )
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-3 margin-bottom-5"
                                            },
                                            [_vm._v(" ")]
                                          ),
                                      _vm._v(" "),
                                      _vm.verrors.firstByRule(
                                        "package_discount[" + sindex + "]",
                                        "numeric"
                                      )
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-3 p-0 margin-bottom-5 validate-warning-msg"
                                            },
                                            [
                                              _vm._v(
                                                "Discount should be numeric"
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "col-3 margin-bottom-5"
                                        },
                                        [_vm._v(" ")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "col-3 margin-bottom-5"
                                        },
                                        [_vm._v(" ")]
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e()
                          }),
                          _vm._v(" "),
                          _c("div", { staticStyle: { clear: "both" } }),
                          _vm._v(" "),
                          _vm.edit_unit_type == "Seat"
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "mb-2 float-right price-range-wrapper",
                                  staticStyle: { cursor: "pointer" },
                                  on: {
                                    click: function($event) {
                                      return _vm.addEditMoreSeat()
                                    }
                                  }
                                },
                                [_vm._v(" + Add More Bundles")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticStyle: { clear: "both" } }),
                          _vm._v(" "),
                          _vm.edit_unit_type == "Seat"
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "mt-3 mb-3 py-2 px-3 subscription_box rounded shadow"
                                },
                                [
                                  _c("div", { staticClass: "row" }, [
                                    _c(
                                      "div",
                                      { staticClass: "col-12 pr-0 bold pb-3" },
                                      [
                                        _vm._v(
                                          "\n                          Additional Seat Price\n                        "
                                        )
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "row" }, [
                                    _c(
                                      "div",
                                      { staticClass: "col-2 pr-0 pt-2" },
                                      [
                                        _vm._v(
                                          "\n                            Yearly:\n                        "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "col-4 pl-0" }, [
                                      _vm._v("\n                        $ "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.edit_additional_seat_price_yearly,
                                            expression:
                                              "edit_additional_seat_price_yearly"
                                          },
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: "required|decimal:2",
                                            expression: "'required|decimal:2'"
                                          }
                                        ],
                                        staticClass:
                                          "col-11 input-text form-control license-range-price",
                                        staticStyle: { "max-width": "78%" },
                                        attrs: {
                                          placeholder: "Price",
                                          name: "yearly_seat_price",
                                          maxlength: "8"
                                        },
                                        domProps: {
                                          value:
                                            _vm.edit_additional_seat_price_yearly
                                        },
                                        on: {
                                          blur: function($event) {
                                            return _vm.formatSeatAdditionalPrice(
                                              $event,
                                              "add",
                                              "yearly"
                                            )
                                          },
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.edit_additional_seat_price_yearly =
                                              $event.target.value
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _vm.verrors.firstByRule(
                                        "yearly_seat_price",
                                        "required"
                                      )
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "text-left margin-bottom-5 validate-warning-msg"
                                            },
                                            [_vm._v("Price is required")]
                                          )
                                        : _vm.verrors.firstByRule(
                                            "yearly_seat_price",
                                            "decimal"
                                          )
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "text-left margin-bottom-5 validate-warning-msg"
                                            },
                                            [
                                              _vm._v(
                                                "Price should be numeric and may contain 2 decimal points"
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-2 pr-0 pt-2" },
                                      [
                                        _vm._v(
                                          "\n                            Monthly:\n                        "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "col-4 pl-0" }, [
                                      _vm._v("\n                        $ "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.edit_additional_seat_price_monthly,
                                            expression:
                                              "edit_additional_seat_price_monthly"
                                          },
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: "required|decimal:2",
                                            expression: "'required|decimal:2'"
                                          }
                                        ],
                                        staticClass:
                                          "col-11 input-text form-control license-range-price",
                                        staticStyle: { "max-width": "78%" },
                                        attrs: {
                                          placeholder: "Price",
                                          name: "monthly_seat_price",
                                          maxlength: "8"
                                        },
                                        domProps: {
                                          value:
                                            _vm.edit_additional_seat_price_monthly
                                        },
                                        on: {
                                          blur: function($event) {
                                            return _vm.formatSeatAdditionalPrice(
                                              $event,
                                              "add",
                                              "monthly"
                                            )
                                          },
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.edit_additional_seat_price_monthly =
                                              $event.target.value
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _vm.verrors.firstByRule(
                                        "monthly_seat_price",
                                        "required"
                                      )
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "text-left margin-bottom-5 validate-warning-msg"
                                            },
                                            [_vm._v("Price is required")]
                                          )
                                        : _vm.verrors.firstByRule(
                                            "monthly_seat_price",
                                            "decimal"
                                          )
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "text-left margin-bottom-5 validate-warning-msg"
                                            },
                                            [
                                              _vm._v(
                                                "Price should be numeric and may contain 2 decimal points"
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ])
                                  ])
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "col-lg-12 col-12 override-padding"
                            },
                            [
                              _vm.edit_unit_type != ""
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "search-padd",
                                      attrs: { id: "purchase-type-wrapper" }
                                    },
                                    [
                                      _c("multiselect", {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: "required",
                                            expression: "'required'"
                                          }
                                        ],
                                        attrs: {
                                          options: _vm.affiliate_options,
                                          "track-by": "name",
                                          label: "name",
                                          placeholder: "Select Affiliates...",
                                          multiple: true,
                                          "close-on-select": false,
                                          "show-labels": false,
                                          name: "affiliate",
                                          id: "affiliate"
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "selection",
                                            fn: function(ref) {
                                              var values = ref.values
                                              var search = ref.search
                                              var isOpen = ref.isOpen
                                              return [
                                                values.length && !isOpen
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "multiselect__single"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            values.length
                                                          ) + " selected"
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            }
                                          }
                                        ]),
                                        model: {
                                          value: _vm.edit_affiliate_selected,
                                          callback: function($$v) {
                                            _vm.edit_affiliate_selected = $$v
                                          },
                                          expression: "edit_affiliate_selected"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _vm.verrors.firstByRule(
                                        "affiliate",
                                        "required"
                                      )
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "margin-bottom-5 validate-warning-msg"
                                            },
                                            [_vm._v("Affiliate is required")]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "margin-bottom-10",
                            staticStyle: { clear: "both" }
                          }),
                          _vm._v(" "),
                          _vm.edit_unit_type == "License"
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "col-lg-12 col-12 override-padding"
                                },
                                [
                                  _c("b-form-select", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required",
                                        expression: "'required'"
                                      }
                                    ],
                                    staticClass: "input-text",
                                    attrs: {
                                      options: _vm.validityDurationOptions,
                                      name: "Validity Duration"
                                    },
                                    model: {
                                      value: _vm.edit_validity_duration,
                                      callback: function($$v) {
                                        _vm.edit_validity_duration = $$v
                                      },
                                      expression: "edit_validity_duration"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _vm.verrors.firstByRule(
                                    "Validity Duration",
                                    "required"
                                  )
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "margin-bottom-5 validate-warning-msg"
                                        },
                                        [
                                          _vm._v(
                                            "Validity Duration is required"
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.edit_unit_type == "Seat"
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "col-lg-12 col-12 override-padding"
                                },
                                [
                                  _c("b-form-select", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required",
                                        expression: "'required'"
                                      }
                                    ],
                                    staticClass: "input-text",
                                    attrs: {
                                      options: _vm.seatValidityDurationOptions,
                                      name: "Validity Duration"
                                    },
                                    model: {
                                      value: _vm.edit_validity_duration,
                                      callback: function($$v) {
                                        _vm.edit_validity_duration = $$v
                                      },
                                      expression: "edit_validity_duration"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _vm.verrors.firstByRule(
                                    "Validity Duration",
                                    "required"
                                  )
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "margin-bottom-5 validate-warning-msg"
                                        },
                                        [
                                          _vm._v(
                                            "Validity Duration is required"
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "margin-bottom-10",
                            staticStyle: { clear: "both" }
                          }),
                          _vm._v(" "),
                          _vm.edit_unit_type != ""
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "col-lg-12 col-12 override-padding"
                                },
                                [
                                  _c("b-form-select", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required",
                                        expression: "'required'"
                                      }
                                    ],
                                    staticClass: "input-text",
                                    attrs: {
                                      options: _vm.packageStatusOptions,
                                      name: "Status"
                                    },
                                    model: {
                                      value: _vm.edit_is_active,
                                      callback: function($$v) {
                                        _vm.edit_is_active = $$v
                                      },
                                      expression: "edit_is_active"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _vm.verrors.firstByRule("Status", "required")
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "margin-bottom-5 validate-warning-msg"
                                        },
                                        [_vm._v("Status is required")]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.edit_unit_type == "License" &&
                          _vm.edit_is_active == "1"
                            ? _c(
                                "div",
                                { staticClass: "license-criteria-wrapper" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "license-criteria-heading" },
                                    [_vm._v("License Redistribution Criteria")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-lg-12 col-12 override-padding"
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.edit_probation_window,
                                            expression: "edit_probation_window"
                                          },
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: "required|numeric",
                                            expression: "'required|numeric'"
                                          }
                                        ],
                                        staticClass:
                                          "input-text form-control license-range-input",
                                        attrs: {
                                          placeholder: "",
                                          name: "Probation Window",
                                          maxlength: "3"
                                        },
                                        domProps: {
                                          value: _vm.edit_probation_window
                                        },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.edit_probation_window =
                                              $event.target.value
                                          }
                                        }
                                      }),
                                      _vm._v(
                                        " days \n                                "
                                      ),
                                      _c("span", {
                                        staticStyle: { "margin-right": "40px" }
                                      }),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.edit_reassign_window,
                                            expression: "edit_reassign_window"
                                          },
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: "required|numeric",
                                            expression: "'required|numeric'"
                                          }
                                        ],
                                        staticClass:
                                          "input-text form-control license-range-input",
                                        attrs: {
                                          placeholder: "",
                                          name: "Reassign Window",
                                          maxlength: "3"
                                        },
                                        domProps: {
                                          value: _vm.edit_reassign_window
                                        },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.edit_reassign_window =
                                              $event.target.value
                                          }
                                        }
                                      }),
                                      _vm._v(
                                        " days \n                                "
                                      ),
                                      _c("span", {
                                        staticStyle: { "margin-right": "30px" }
                                      }),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.edit_no_of_reassign,
                                            expression: "edit_no_of_reassign"
                                          },
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: "required|numeric",
                                            expression: "'required|numeric'"
                                          }
                                        ],
                                        staticClass:
                                          "input-text form-control license-range-input",
                                        attrs: {
                                          placeholder: "",
                                          name: "No Of Reassign",
                                          maxlength: "1"
                                        },
                                        domProps: {
                                          value: _vm.edit_no_of_reassign
                                        },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.edit_no_of_reassign =
                                              $event.target.value
                                          }
                                        }
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-lg-12 col-12 override-padding license-criteria-label"
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "license-criteria-label"
                                        },
                                        [_vm._v("Probation Window ")]
                                      ),
                                      _vm._v(" "),
                                      _c("span", {
                                        staticStyle: { "margin-right": "60px" }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "license-criteria-label"
                                        },
                                        [_vm._v("Reassign Window ")]
                                      ),
                                      _vm._v(" "),
                                      _c("span", {
                                        staticStyle: { "margin-right": "50px" }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "license-criteria-label"
                                        },
                                        [_vm._v("# of Reassigns")]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass: "margin-bottom-10",
                                    staticStyle: { clear: "both" }
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "row" }, [
                                    _vm.verrors.firstByRule(
                                      "Probation Window",
                                      "required"
                                    )
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-4 margin-bottom-5 validate-warning-msg"
                                          },
                                          [
                                            _vm._v(
                                              "Probation Window is required"
                                            )
                                          ]
                                        )
                                      : _vm.verrors.firstByRule(
                                          "Probation Window",
                                          "numeric"
                                        )
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-4 margin-bottom-5 validate-warning-msg"
                                          },
                                          [
                                            _vm._v(
                                              "Probation Window should be numeric"
                                            )
                                          ]
                                        )
                                      : _c(
                                          "div",
                                          {
                                            staticClass: "col-4 margin-bottom-5"
                                          },
                                          [_vm._v(" ")]
                                        ),
                                    _vm._v(" "),
                                    _vm.verrors.firstByRule(
                                      "Reassign Window",
                                      "required"
                                    )
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-4 margin-bottom-5 validate-warning-msg"
                                          },
                                          [
                                            _vm._v(
                                              "Reassign Window is required"
                                            )
                                          ]
                                        )
                                      : _vm.verrors.firstByRule(
                                          "Reassign Window",
                                          "numeric"
                                        )
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-4 margin-bottom-5 validate-warning-msg"
                                          },
                                          [
                                            _vm._v(
                                              "Reassign Window should be numeric"
                                            )
                                          ]
                                        )
                                      : _c(
                                          "div",
                                          {
                                            staticClass: "col-4 margin-bottom-5"
                                          },
                                          [_vm._v(" ")]
                                        ),
                                    _vm._v(" "),
                                    _vm.verrors.firstByRule(
                                      "No Of Reassign",
                                      "required"
                                    )
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-4 margin-bottom-5 validate-warning-msg"
                                          },
                                          [
                                            _vm._v(
                                              " No Of Reassign is required"
                                            )
                                          ]
                                        )
                                      : _vm.verrors.firstByRule(
                                          "No Of Reassign",
                                          "numeric"
                                        )
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-4 margin-bottom-5 validate-warning-msg"
                                          },
                                          [
                                            _vm._v(
                                              "No Of Reassign should be numeric"
                                            )
                                          ]
                                        )
                                      : _c(
                                          "div",
                                          {
                                            staticClass: "col-4 margin-bottom-5"
                                          },
                                          [_vm._v(" ")]
                                        )
                                  ])
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "margin-bottom-10",
                            staticStyle: { clear: "both" }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-12 override-padding" },
                            [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-red col-3 float-left input-height-25",
                                  on: {
                                    click: function($event) {
                                      return _vm.updatePackage()
                                    }
                                  }
                                },
                                [_c("b", [_vm._v("Update")])]
                              )
                            ]
                          )
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "col-3 override-padding",
                    attrs: { slot: "footer" },
                    slot: "footer"
                  })
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5c7bf526", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c7bf526","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/subscriptionlevel_list.vue
// module id = null
// module chunks = 